<template>
  <div class="inspection-record">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>巡检记录管理</span>
        <div class="header-buttons">
          <el-button type="success" @click="refreshList" icon="el-icon-refresh">刷新</el-button>
        </div>
      </div>

      <!-- 筛选器 -->
      <el-form :inline="true" :model="filter" class="demo-form-inline">
        <!-- 只有管理员才能看到学校选择器 -->
        <el-form-item v-if="userRole !== 'school_manager'" label="学校">
          <el-select
              v-model="filter.school_id"
              placeholder="请选择学校"
              clearable
              style="width: 200px;"
          >
            <el-option v-for="item in schoolList" :key="item.id" :label="item.name" :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="洗衣房">
          <el-select v-model="filter.laundry_id" placeholder="请选择洗衣房" clearable style="width: 200px;">
            <el-option v-for="item in laundryList" :key="item.id" :label="item.name" :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="保洁员">
          <el-select v-model="filter.cleaner_id" placeholder="请选择保洁员" clearable style="width: 200px;">
            <el-option v-for="item in cleanerList" :key="item.id" :label="item.name" :value="item.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="filter.status" placeholder="请选择状态" clearable style="width: 150px;">
            <el-option label="正常" value="正常"/>
            <el-option label="异常" value="异常"/>
            <el-option label="需要维修" value="需要维修"/>
          </el-select>
        </el-form-item>
        <el-form-item label="巡检日期">
          <el-date-picker
              v-model="filter.inspection_date"
              type="date"
              placeholder="选择巡检日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              style="width: 200px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getInspectionRecords">查询</el-button>
          <el-button @click="resetFilter">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 巡检记录列表 -->
      <el-table :data="inspectionList" style="width: 100%; margin-top: 20px;" v-loading="tableLoading">
        <el-table-column prop="school_name" label="所属学校" min-width="120"/>
        <el-table-column prop="laundry_name" label="洗衣房" min-width="120"/>
        <el-table-column prop="cleaner_name" label="保洁员" min-width="100"/>
        <el-table-column prop="cleaner_phone" label="保洁员电话" min-width="120"/>
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="location" label="位置信息" min-width="150"/>
        <el-table-column prop="photo_url" label="照片" width="120" align="center">
          <template slot-scope="scope">
            <div>
              <img
                  v-if="scope.row.photo_url"
                  :src="getImageUrl(scope.row.photo_url)"
                  alt="巡检照片"
                  style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px; margin-right: 8px;"
              />
              <el-button
                  v-if="scope.row.photo_url"
                  size="mini"
                  type="primary"
                  @click="viewPhoto(scope.row.photo_url)"
              >查看照片
              </el-button>
              <el-button v-else size="mini" type="info" disabled>无照片</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="巡检时间" width="180" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注信息" min-width="150"/>
      </el-table>

      <!-- 分页器 -->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.current_page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total_records"
          style="margin-top: 20px; text-align: right;">
      </el-pagination>
    </el-card>

    <!-- 照片查看对话框 -->
    <el-dialog title="巡检照片" :visible.sync="photoDialogVisible" width="50%">
      <div style="text-align: center;">
        <img :src="currentPhotoUrl" alt="巡检照片" style="max-width: 100%; max-height: 500px;"/>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'InspectionRecord',
  props: {
    // 接收外部传入的筛选条件
    filterLaundryId: {
      type: [String, Number],
      default: ''
    },
    filterCleanerId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      baseURL: "https://stwc7777.com",
      // baseURL: "http://localhost:8090",
      tableLoading: false,
      photoDialogVisible: false,
      currentPhotoUrl: '',
      userRole: window.sessionStorage.getItem('userRole'),

      // 筛选条件
      filter: {
        school_id: '',
        laundry_id: '',
        cleaner_id: '',
        status: '',
        inspection_date: ''
      },

      // 数据列表
      inspectionList: [],
      laundryList: [],
      cleanerList: [],
      schoolList: [],

      // 分页信息
      pagination: {
        current_page: 1,
        total_pages: 1,
        total_records: 0,
        page_size: 10,
        has_more: false
      }
    }
  },
  created() {
    // 处理路由参数
    if (this.$route && this.$route.query && this.$route.query.cleaner_name) {
      // 查找cleanerList中对应的id
      this.getCleanerList().then(() => {
        const cleaner = this.cleanerList.find(item => item.name === this.$route.query.cleaner_name)
        if (cleaner) {
          this.filter.cleaner_id = cleaner.id
        }
        this.initFilter()
        this.getLaundryList()
        this.getSchoolList()
        this.getInspectionRecords()
      })
      return;
    }

    // 处理school_id路由参数（仅管理员可用）
    if (this.userRole !== 'school_manager' && this.$route && this.$route.query && this.$route.query.school_id) {
      this.filter.school_id = parseInt(this.$route.query.school_id)
    }

    // 学校管理者不显示学校选择器，也不发送学校筛选参数
    if (this.userRole === 'school_manager') {
      this.filter.school_id = ''
    }

    this.initFilter()
    this.getLaundryList()
    this.getCleanerList()
    this.getSchoolList()
    this.getInspectionRecords()
  },
  watch: {
    // 监听外部传入的筛选条件变化
    filterLaundryId(newVal) {
      this.filter.laundry_id = newVal
      this.getInspectionRecords()
    },
    filterCleanerId(newVal) {
      this.filter.cleaner_id = newVal
      this.getInspectionRecords()
    }
  },
  methods: {
    // 初始化筛选条件
    initFilter() {
      if (this.filterLaundryId) {
        this.filter.laundry_id = this.filterLaundryId
      }
      if (this.filterCleanerId) {
        this.filter.cleaner_id = this.filterCleanerId
      }
    },

    // 获取巡检记录
    async getInspectionRecords() {
      this.tableLoading = true
      const params = {
        page: this.pagination.current_page,
        limit: this.pagination.page_size
      }
      if (this.filter.laundry_id) params.laundry_id = this.filter.laundry_id
      if (this.filter.cleaner_id) params.cleaner_id = this.filter.cleaner_id
      if (this.filter.status) params.status = this.filter.status
      if (this.filter.inspection_date) params.date = this.filter.inspection_date
      // 只有管理员才能发送学校筛选参数
      if (this.userRole !== 'school_manager' && this.filter.school_id) {
        params.school_id = this.filter.school_id
      }

      try {
        const {data: res} = await this.$http.get('/api/inspection/admin', {params})
        if (res.status !== 0) return this.$message.error('获取巡检记录失败')

        // 更新数据列表和分页信息
        this.inspectionList = res.data.list || []
        this.pagination = {
          current_page: res.data.pagination.current_page || 1,
          total_pages: res.data.pagination.total_pages || 1,
          total_records: res.data.pagination.total_records || 0,
          page_size: res.data.pagination.page_size || 10,
          has_more: res.data.pagination.has_more || false
        }
      } catch (error) {
        console.error('获取巡检记录失败:', error)
        this.$message.error('获取巡检记录失败')
      } finally {
        this.tableLoading = false
      }
    },

    // 获取洗衣房列表
    async getLaundryList() {
      try {
        const { data: res } = await this.$http.get('/api/laundry/list')
        if (res.status !== 0) return this.$message.error('获取洗衣房列表失败')

        // 如果是学校管理者，只显示自己学校的洗衣房
        if (this.userRole === 'school_manager') {
          const userInfo = JSON.parse(window.sessionStorage.getItem('userInfo') || '{}')
          this.laundryList = res.data.filter(item => item.school_id == userInfo.school_id)
        } else {
          this.laundryList = res.data
        }
      } catch (error) {
        console.error('获取洗衣房列表失败:', error)
        this.$message.error('获取洗衣房列表失败')
      }
    },


    // 获取保洁员列表
    async getCleanerList() {
      try {
        const {data: res} = await this.$http.get('/api/cleaner/list')
        if (res.status !== 0) return this.$message.error('获取保洁员列表失败')

        // 如果是学校管理者，只显示自己学校的保洁员
        if (this.userRole === 'school_manager') {
          const userInfo = JSON.parse(window.sessionStorage.getItem('userInfo') || '{}')
          this.cleanerList = res.data.filter(item =>
              item.school_ids && item.school_ids.includes(Number(userInfo.school_id))
          )
        } else {
          this.cleanerList = res.data
        }
      } catch (error) {
        console.error('获取保洁员列表失败:', error)
        this.$message.error('获取保洁员列表失败')
      }
    },

    // 获取学校列表
    async getSchoolList() {
      try {
        const {data: res} = await this.$http.get('/api/school/list')
        if (res.status !== 0) return this.$message.error('获取学校列表失败')
        this.schoolList = res.data
      } catch (error) {
        console.error('获取学校列表失败:', error)
        this.$message.error('获取学校列表失败')
      }
    },

    // 重置筛选条件
    resetFilter() {
      this.filter = {
        school_id: this.userRole === 'school_manager' ? '' : this.filter.school_id, // 学校管理者不重置学校ID
        laundry_id: '',
        cleaner_id: '',
        status: '',
        inspection_date: ''
      }
      this.pagination.current_page = 1
      this.getInspectionRecords()
    },

    // 查看照片
    viewPhoto(photoUrl) {
      // 拼接baseURL来正确显示照片
      this.currentPhotoUrl = this.baseURL + photoUrl
      this.photoDialogVisible = true
    },

    // 分页大小改变
    handleSizeChange(size) {
      this.pagination.page_size = size
      this.pagination.current_page = 1
      this.getInspectionRecords()
    },

    // 当前页改变
    handleCurrentChange(page) {
      this.pagination.current_page = page
      this.getInspectionRecords()
    },

    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString('zh-CN')
    },

    // 获取状态标签类型
    getStatusType(status) {
      switch (status) {
        case '正常':
          return 'success'
        case '异常':
          return 'warning'
        case '需要维修':
          return 'danger'
        default:
          return 'info'
      }
    },

    // 获取图片URL
    getImageUrl(photoUrl) {
      return this.baseURL + photoUrl
    },

    // 刷新列表
    refreshList() {
      this.resetFilter()
      this.getInspectionRecords()
    }
  }
}
</script>

<style scoped>
.inspection-record {
  padding: 20px;
}

.box-card {
  margin-bottom: 20px;
}

.header-buttons {
  float: right;
}

.header-buttons .el-button {
  margin-left: 10px;
}

.demo-form-inline {
  background-color: #f5f5f5;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.el-form-item {
  margin-bottom: 10px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>